"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const PdfCanvasPreview = dynamic(
  () =>
    import("@/components/pdf-canvas-preview").then(
      (module) => module.PdfCanvasPreview,
    ),
  { ssr: false },
);

type PdfPreviewProps = {
  downloadPath: string;
  title: string;
};

function PreviewSkeleton() {
  return (
    <div className="absolute inset-0 z-10 bg-background p-5 sm:p-6">
      <div className="mb-4 h-4 w-40 animate-pulse rounded bg-muted" />
      <div className="space-y-3">
        <div className="h-4 w-full animate-pulse rounded bg-muted" />
        <div className="h-4 w-11/12 animate-pulse rounded bg-muted" />
        <div className="h-4 w-10/12 animate-pulse rounded bg-muted" />
      </div>
      <div className="mt-5 aspect-[1.414/1] w-full animate-pulse rounded-xl bg-muted/80" />
    </div>
  );
}

export function PdfPreview({ downloadPath, title }: PdfPreviewProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div
      data-lenis-prevent="true"
      className={`relative w-full h-full overflow-hidden flex flex-col bg-background${isLoading ? " min-h-[14rem]" : ""}`}
    >
      {isLoading && <PreviewSkeleton />}
      {isMounted ? (
        <PdfCanvasPreview
          key={downloadPath}
          downloadPath={downloadPath}
          title={title}
          onReady={() => setIsLoading(false)}
        />
      ) : null}
    </div>
  );
}
